import { render, staticRenderFns } from "./NewEndorsement.vue?vue&type=template&id=24ece46a"
import script from "./NewEndorsement.vue?vue&type=script&lang=js"
export * from "./NewEndorsement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports